import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { ModalService } from '../shared/modal.service';
import { MatIconModule } from '@angular/material/icon';
import { IconModule } from '../shared/icon.module';
import { PSIC_COMPONENTS } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { selectSelectedSection } from '../store/selection/selection.selector';
import { SelectionService } from '../services/selection.service';

@Component({
    selector: 'app-desktop-list-view',
    templateUrl: './desktop-list-view.component.html',
    styleUrls: ['./desktop-list-view.component.scss'],
    imports: [MatIconModule, IconModule, ...PSIC_COMPONENTS],
})
export class DesktopListViewComponent implements OnInit, OnDestroy {
    @Input() data: any;
    @Input() end: boolean = false;
    isHighlighted: boolean = false;
    iconPath = '';
    private sectionSubscription: Subscription;
    isLandingPage: boolean = true;
    isNavOpen = false;
    private mutationObserver: MutationObserver;

    constructor(private modalService: ModalService, private store: Store, private selectionService: SelectionService) {}

    private navListener = () => {
        this.isNavOpen = document.body.classList.contains('nav-open');
    };

    ngOnInit() {
        this.sectionSubscription = this.store.select(selectSelectedSection).subscribe((section) => {
            this.isHighlighted = this.data?.name === section;
        });
        this.selectionService.isLandingPage$.subscribe((value) => {
            this.isLandingPage = value;
        });
        document.body.addEventListener('classChange', this.navListener);
        // observe body class changes
        this.mutationObserver = new MutationObserver(this.navListener);
        this.mutationObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    ngOnDestroy() {
        if (this.sectionSubscription) {
            this.sectionSubscription.unsubscribe();
        }
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
    }

    onHelpIconClick(data: any) {
        const dialog = {
            type: 'actionDialog',
            message: data.caption,
            messageExt: data.helpText,
            confirm: 'Ok, got it.',
            cancel: '',
            fields: [],
        };

        this.modalService.confirm(dialog, 'modal-dialog-centered');
    }

    toggleCollapse(item: any) {
        item.isOpen = !item.isOpen;
    }
}
